/**
* Representative Map JS
* -----------------------------------------------------------------------------
*
* All the JS for the Representative Map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'representative-map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( document ).on( 'keyup', '.representative-map input', function() {
        if ( $( this ).val().length > 5 ) {
          $( this ).val( $( this ).val().substr( 0, 5 ) );
        }
      } );

      $( '.representative-map form' ).on( 'submit', function( e ) {
        e.preventDefault();
        if ( $( '.representative-map input' ).val() ) {
          $.ajax( {
            url: 'https://zip.getziptastic.com/v2/US/' + $( '.representative-map input' ).val(),
            cache: false,
            dataType: 'json',
            type: 'GET',
            success: function( result, success ) {
              console.log( result.state_short );

              const data = {
                'state': result.state_short,
                'zip': $( '.representative-map input' ).val(),
              };

              $.ajax( {
                type: 'GET',
                url: site_info.wpApiSettings.ll + 'cpt/filter', // note that cpt/filter is the path set in our new route in routes.php
                data: data,
                beforeSend: function( xhr ) {
                  xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
                  xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
                  doingAjax = true;
                },
                success: function( data ) {
                  console.log( data );
                  $.magnificPopup.open( {
                    items: {
                      src: data['popup'],
                      type: 'inline',
                    },
                  } );
                },
                complete: function( jqXHR, status ) {
                  doingAjax = false;
                },
              } );
            },
          } );
        }
      } );


      // get current location information
      $.ajax( {
        url: 'https://geolocation-db.com/jsonp',
        jsonpCallback: 'callback',
        dataType: 'jsonp',
        success: function( location ) {
          if ( location.postal ) {
            $( 'input[name="zip-search"]' ).val( location.postal ).closest( 'form' ).trigger( 'submit' );
          } else {
            console.log( 'Could not get location zip code from https://geolocation-db.com/jsonp' );
          }
        },
      } );

      $( '.representative-map path[data-state]' ).on( 'click', function() {
        const data = {
          'state': $( this ).attr( 'data-state' ),
        };

        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            $.magnificPopup.open( {
              items: {
                src: data['popup'],
                type: 'inline',
              },
            } );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'representative-map', COMPONENT );
} )( app );
